import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Biblioteca } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useBiblioteca, useBibliotecaDelete, useBibliotecaUpdate } from "../../hooks/biblioteche"
import { useMemo } from "react"
import { initialValuesBiblioteca, validationSchemaBiblioteca } from "./BibliotecaCommon"
import BibliotecaForm from "./BibliotecaForm"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function BibliotecaUpdate() {
  const updateBiblioteca = useBibliotecaUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: biblioteca } = useBiblioteca(Number(id))

  const [modalStateDeleteBiblioteca, modalActionsDeleteBiblioteca] = useModalTrigger()

  const deleteBiblioteca = useBibliotecaDelete()

  useBreadcrumbs([{ label: "Biblioteche", href: "/biblioteche/biblioteche" }, { label: "Dettaglio Biblioteca" }])

  const initialValues = useMemo(() => initialValuesBiblioteca(biblioteca) as Biblioteca, [biblioteca])
  const validationSchema = useMemo(() => validationSchemaBiblioteca(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{biblioteca?.nome}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteBiblioteca.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateBiblioteca.mutateAsync(values as Biblioteca).then(() => {
                navigate(`/biblioteche/biblioteche`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <BibliotecaForm />
                </Container>
                <BottomFormFixed url="/biblioteche/biblioteche" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteBiblioteca.isOpen}
        onClose={modalActionsDeleteBiblioteca.close}
        onDelete={() => {
          return deleteBiblioteca.mutateAsync(biblioteca?.id).then(() => {
            navigate(`/biblioteche/biblioteche`)
          })
        }}
        message="Sei sicuro di voler eliminare questa biblioteca?"
        title="Elimina biblioteca"
      />
    </Layout>
  )
}
